<template>
  <div class="qa-block">
    <div class="question-section" style="margin-top: 8px" v-show="inversion">
      <div class="question-content">
        {{ text }}
      </div>
    </div>
    <div
      class="answer-section"
      v-show="!inversion"
      style="margin-top: 0px; padding: 0 0.5rem"
    >
      <div class="hyyueyue">
        <svg-icon
          class="hyAiYyIcon"
          style="width: 35px; height: 35px"
          icon-class="hyAiYY"
        ></svg-icon>
      </div>
      <div class="answer-card-content">
        <span class="hyAiYyWord">
          <svg-icon
            class="hyAiYyIcon"
            style="width: 30px; height: 30px"
            icon-class="hyAiYY"
          >
          </svg-icon>
          <span style="margin-left: 5px;">悦悦：</span>
        </span>
        <div class="answer-card">
          <div class="answer-content">
            <div class="sc-gLDzan diOrVY">
              <hyAiTextComponent
                ref="textRef"
                :inversion="inversion"
                :error="error"
                :text="text"
                :reasoning="reasoning"
                :loading="loading"
                :tuiLi="tuiLi"
                :as-raw-text="inversion"
                :idVal="idVal"
                :des="des"
              />
            </div>
          </div>
        </div>
        <div class="list-item-opera" style="align-items: center;padding-bottom: 8px;border-bottom: 1px solid #eee;">
          <!-- <div class="opera-again" title="复制" style="display: flex;align-items: center;margin-right:8px;">
            
          </div> -->
          <div
            class="opera-again"
            @click="del"
            title="删除"
            style="display: flex; align-items: center"
          >
            <van-icon name="delete-o" size="20" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import hyAiTextComponent from "./Text.vue";
import { createGguid } from "@/utils/index.js";
import { copyToClip } from "@/utils/index.js";
export default {
  props: {
    dateTime: {
      type: String,
      default: "",
    },
    uuid: {
      type: String,
      default: "",
    },
    id: {
      type: [String, Number],
      default: 0,
    },
    text: {
      type: String,
      default: "",
    },
    reasoning: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
    inversion: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 1是AI助手 2是弹出框数据分析
    type: {
      type: Number,
      default: 1,
    },
    tuiLi: {
      type: Boolean,
      default: false,
    },
    des: {
      type: String,
      default: "",
    },
  },
  components: {
    hyAiTextComponent,
  },
  data() {
    return {
      textRef: null,
      idVal: createGguid(),
    };
  },
  methods: {
    del() {
      Dialog.confirm({
        title: "系统提示",
        message: "你确定要删除吗？",
      }).then(() => {
        let obj = {
          uuid: this.uuid,
          id: this.id,
        };
        this.$emit("delChat", obj);
      });
    },
  },
};
</script>
<style lang="less">
.del-user-content {
  margin-left: 6px;
  cursor: pointer;
  text-decoration: underline;
  color: #1ee91e;
}
.diOrVY .markdown-body {
  text-size-adjust: 100%;
  margin: 0px;
  color: rgb(36, 41, 47);
  background-color: rgb(255, 255, 255);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans",
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 30px;
  line-height: 1.5;
  overflow-wrap: break-word;
  * {
    user-select: text !important;
  }
}
.diOrVY .markdown-body::after {
  display: table;
  clear: both;
  content: "";
}
</style>
<style lang="less" scoped>
.answer-section,
.qa-block {
  width: 100%;
}
.answer-section {
  display: flex;
}
.hyyueyue {
  min-width: 70px !important;
  display: none;
}
.hyAiYyWord {
  font-size: 28px !important;
  color: #666;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.question-section {
  padding: 0px 0.5rem;
  width: 100%;
  display: flex;
  justify-content: right;
}
.question-content {
  align-items: center;
  padding: 16px 20px;
  border-radius: 16px;
  display: flex;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-size: 30px;
  font-weight: 500;
  justify-content: center;
  line-height: 48px;
  word-break: break-all;
  user-select: text !important;
  background: #fff;
  color: #000;
  max-width: 80% !important;
  text-align: justify;
  // box-shadow: 0 0 0.13333rem 0 rgba(0, 0, 0, 0.1);
  // background: rgb(233, 233, 233);
}
.answer-card-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin: 0 auto;
  // max-width: calc(100% - 70px) !important;
  max-width: 100% !important;
  padding-top: 8px !important;
  // padding-left: 12px !important;
}
.answer-card {
  background: #fff;
  border: 1px solid #e8e9eb;
  border-radius: 16px;
  display: flex;

  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 16px 16px 12px;
  // box-shadow: 0 0 0.13333rem 0 rgba(0, 0, 0, 0.1);
  .answer-content {
    color: #333;
    flex-grow: 1;
    font-size: 30px;
    line-height: 1.6;
    margin-bottom: 16px;
  }
}
.list-item-opera {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
  width: 100%;
  justify-content: right;
}
.list-item-opera .opera-copy {
  cursor: pointer;
  display: flex;
  height: 20px;
  margin-right: 8px;
  position: relative;
  width: 20px;
}
.list-item-opera .opera-again {
  color: #84868c;
  cursor: pointer;
  // height: 20px;
  white-space: nowrap;
  // width: 20px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
</style>
